// extracted by mini-css-extract-plugin
export default {"category":"AddTask_category__bjufT","addTaskIcon":"AddTask_addTaskIcon__VBQ7H","emptyButton":"AddTask_emptyButton__aHFI6"};